import * as React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { Flex, Box } from '@rebass/grid/emotion'

import { dimensions, linkCSS, linkCSSInverted } from '../styles/variables'
import css from '@emotion/css'
import { FaFacebookF } from 'react-icons/fa'
import LanguageChooser from '../components/LanguageChooser'
import LocalizedLink from '../i18n/LocalizedLink'
import { LocaleContext } from '../i18n'
import { InlineLink } from '../components/Link'

const TopBarBase = styled.div`
  background: #000;
  padding: 10px 0;
`

const TopBarContainer = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`

export const TopBar = () =>
  <TopBarBase>
    <TopBarContainer>
      <Flex alignItems="center">
        <InlineLink
          css={css`
            height: 16px;
          `}
          href="https://www.facebook.com/kamilla.baar.31/"
        >
          <FaFacebookF css={linkCSSInverted} />
        </InlineLink>
        <Box width={1} />
        <LanguageChooser />
      </Flex>
    </TopBarContainer>
  </TopBarBase>

const StyledHeader = styled.header`
  padding: 0 ${dimensions.containerPadding}rem;
`

// color: ${colors.black};
const TitleLink = styled(LocalizedLink)`
  font-size: 1.3rem;
  font-weight: 400;
  color: #000;
  margin: 5px;

  &:focus,
  &:hover {
    text-decoration: none;
  }

  @media (min-width: 420px) {
    font-size: 1.5rem;
  }
`

// TODO externalize this style to variables
// css -> comon with Page links
const pageLinkCSS =
  css`
  font-size: 1rem;
  font-weight: 400;
  margin: 5px;
  ${linkCSS}
`

const PageLink = styled(LocalizedLink)`${pageLinkCSS}`

interface HeaderProps {
  title: string
}

const HR = () =>
  <div css={css`
      border-bottom: 1px solid #e6e6e6;
      height: 10px;
      width: 50%;
      `} />

const Header: React.SFC<HeaderProps> = ({ title }) => (
  <LocaleContext.Consumer>{({ t }) =>
    <StyledHeader>
      <Flex
        alignItems="center"
        flexDirection="column"
        pt={4}
      >
        <Box m="auto" mb={4}>
          <TitleLink to="/">{title}</TitleLink>
        </Box>
        <Box m="auto" mb={4}>
          <PageLink to="/about/">{t('about.menu')}</PageLink>
          <PageLink to="/live/">{t('live.menu')}</PageLink>
          <PageLink to="/">{t('pictures.menu')}</PageLink>
        </Box>
        <HR />
      </Flex>
    </StyledHeader>
  }</LocaleContext.Consumer>

)

Header.defaultProps = {
  title: "Kam Baar!"
}

export default Header
